import React from 'react'
import { MultipleChoiceCellStyles } from './Style'

const MultipleChoiceCell = (props) => {
    const { original } = props.row
    const { correct_count, total_count } = original?.multiple_choice_calculations || {}

    return (
        <MultipleChoiceCellStyles>
            {correct_count && total_count ?
                `${correct_count} מתוך ${total_count}` :
                null}
        </MultipleChoiceCellStyles>
    )
}

export default MultipleChoiceCell